<template>
    <div>
        <Card>
            <Card>
                <p slot="title">{{t.journal.searchName}}</p>
                <Form :model="formItem" :label-width="90" label-position="right">
                    <Row :gutter="16">
                        <Col span="8">
                            <Form-item :label="t.journal.title">
                                <Input v-model="formItem.title"
                                       :placeholder="msgUtil.placeholderRequired(t.journal.title)"></Input>
                            </Form-item>
                        </Col>
                        <Col span="8">
                            <Form-item :label="t.journal.type">
                                <Select v-model="formItem.type" clearable style="width: 100% !important"
                                        :placeholder="msgUtil.placeholderSelected(t.journal.type)">
                                    <Option value="0">{{t.journal.monthJournal}}</Option>
                                    <Option value="1">{{t.journal.dayJournal}}</Option>
                                </Select>
                            </Form-item>
                        </Col>
                        <Col span="8">
                            <Form-item :label="t.journal.releaseDate" v-if="formItem.type==='1'">
                                <DatePicker type="month" format="yyyy/MM"
                                            v-model="formItem.releaseDate" style="width: 100% !important"
                                            :editable="false"
                                            @on-change="handleChangeReleaseDate"
                                            :placeholder="msgUtil.placeholderSelected(t.journal.releaseDate)">
                                </DatePicker>
                            </Form-item>
                            <Form-item :label="t.journal.releaseDate" v-else>
                                <DatePicker type="year" format="yyyy"
                                            v-model="formItem.releaseDate" style="width: 100% !important"
                                            :editable="false"
                                            @on-change="handleChangeReleaseDate"
                                            :placeholder="msgUtil.placeholderSelected(t.journal.releaseDate)">
                                </DatePicker>
                            </Form-item>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="8">
                            <Form-item :label="t.journal.status">
                                <Select v-model="formItem.status" clearable style="width: 100% !important"
                                        :placeholder="msgUtil.placeholderRequired(t.journal.status)">
                                    <Option value="1">{{t.journal.open}}</Option>
                                    <Option value="0">{{t.journal.close}}</Option>
                                </Select>
                            </Form-item>
                        </Col>
                        <Col span="8">
                            <Form-item :label="t.journal.createStartTime">
                                <DatePicker type="datetime" format="yyyy/MM/dd HH:mm:ss"
                                            v-model="formItem.createStartTime" style="width: 100% !important"
                                            :placeholder="msgUtil.placeholderRequired(t.journal.createStartTime)"
                                            :options="createStartTimeOption"
                                            @on-change="onCreateStartTimeChange"></DatePicker>
                            </Form-item>
                        </Col>
                        <Col span="8">
                            <Form-item :label="t.journal.createEndTime">
                                <DatePicker type="datetime" format="yyyy/MM/dd HH:mm:ss"
                                            v-model="formItem.createEndTime"
                                            style="width: 100% !important"
                                            :placeholder="msgUtil.placeholderRequired(t.journal.createEndTime)"
                                            :options="createEndTimeOption"
                                            @on-change="onCreateEndTimeChange"></DatePicker>
                            </Form-item>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="24">
                            <Button type="primary" icon="ios-search" style="float: right;" @click="search(true)">
                                {{msgUtil.message.action.search}}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Card>
            <Row class="margin-top-10">
                <Col span="12">
                    <sort-button-group :buttons="sortButton" @on-order="orderClick"/>
                </Col>
                <Col style="text-align:right;" span="12">
                    <router-link to="./add">
                        <Button icon="md-add">{{msgUtil.message.action.add}}</Button>
                    </router-link>
                    <Button icon="ios-trash" @click="delAll">{{msgUtil.message.action.deleteAll}}</Button>
                </Col>
            </Row>
            <Row class="margin-top-10">
                <Table ref="selection" :context="self" :columns="columns" :data="data" :loading="loading"
                       @on-selection-change="rowSelect"></Table>
            </Row>
            <Row class="margin-top-10" type="flex" justify="end">
                <Page ref="page" :total="total" show-total show-sizer @on-change="pageChange"
                      @on-page-size-change="pageSizeChange">
                    {{msgUtil.message.page.total}} {{ total }} {{msgUtil.message.page.paper}}
                </Page>
            </Row>
        </Card>
    </div>
</template>
<script>
import { Message, Tag } from 'iview';
import { del, delAll, getJournalList } from '@/api/journal';
import sortButtonGroup from '@/components/sort-button-group.vue';

export default {
    name: 'content_journal_list',
    components: {
        sortButtonGroup,
    },
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;

        const renderTitle = (h, params) => {
            const row = params.row;
            return h('div', [
                h(
                    'router-link',
                    {
                        props: {
                            to: './detail/' + row.id,
                        },
                    },
                    row.title
                ),
            ]);
        };
        const renderType = (h, params) => {
            const row = params.row;
            const color = row.type === '0' ? 'success' : row.type === '1' ? 'primary' : 'success';
            const text =
                row.type === '0'
                    ? t.journal.monthJournal
                    : row.type === '1'
                        ? t.journal.dayJournal
                        : t.journal.monthJournal;
            return h(
                'Tag',
                {
                    props: {
                        type: 'border',
                        color: color,
                    },
                },
                text
            );
        };
        const renderReleaseDate = (h, params) => {
            const row = params.row;
            const text =
                row.type === '0'
                    ? row.releaseYear + '/' + row.releaseMonth
                    : row.releaseYear + '/' + row.releaseMonth + '/' + row.releaseDay;
            return h(
                'Tag',
                {
                    props: {
                        type: 'border',
                    },
                },
                text
            );
        };
        const renderStatus = (h, params) => {
            const row = params.row;
            const color = row.status === '0' ? 'error' : row.status === '1' ? 'success' : 'error';
            const text = row.status === '0' ? t.journal.close : row.status === '1' ? t.journal.open : t.journal.close;
            return h(
                'Tag',
                {
                    props: {
                        type: 'border',
                        color: color,
                    },
                },
                text
            );
        };

        const renderAction = (h, params) => {
            const row = params.row;
            return h('button-group', [
                h(
                    'i-button',
                    {
                        props: {
                            type: 'primary',
                            size: 'small',
                            to: './edit/' + row.id,
                        },
                    },
                    msgUtil.message.action.edit
                ),
                h(
                    'i-button',
                    {
                        props: {
                            type: 'error',
                            size: 'small',
                            style: 'margin-left:5px',
                        },
                        on: {
                            click: this.del.bind(this, row.id),
                        },
                    },
                    msgUtil.message.action.delete
                ),
            ]);
        };
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            // 排序btn
            sortButton: [
                { key: 'title', value: t.sortButton.title, order: 0 },
                { key: 'releaseYear', value: t.sortButton.releaseYear, order: 0 },
                { key: 'status', value: t.sortButton.status, order: 0 },
                { key: 'createTime', value: t.sortButton.createTime, order: 0 },
            ],
            // 入力条件
            formItem: {
                title: '',
                type: '',
                status: '',
                releaseDate: null,
                releaseYear: null,
                releaseMonth: null,
                releaseDay: null,
                createTime: '',
                createStartTime: '',
                createEndTime: '',
                oa: '',
                od: '',
                current: 1,
                size: 10,
            },
            createStartTimeOption: {},
            createEndTimeOption: {},
            selectIds: [],
            data: [],
            total: 0,
            // table定义列
            columns: [
                { title: '', type: 'selection', align: 'center', width: 44 },
                { title: t.table.id, key: 'id', align: 'center', width: 176 },
                { title: t.table.title, align: 'center', key: 'title', tooltip: true, render: renderTitle },
                { title: t.table.type, key: 'type', align: 'center', width: 130, render: renderType },
                { title: t.table.releaseDate, width: 170, key: 'releaseDate', render: renderReleaseDate },
                { title: t.table.createTime, width: 170, key: 'createTime' },
                {
                    title: t.table.status,
                    key: 'status',
                    align: 'center',
                    width: 100,
                    render: renderStatus,
                },
                {
                    title: msgUtil.message.action.name,
                    key: 'action',
                    align: 'center',
                    width: 130,
                    fixed: 'right',
                    render: renderAction,
                },
            ],
            loading: false,
        };
    },
    methods: {
        //排序
        async orderClick(btn) {
            this.formItem.oa = '';
            this.formItem.od = '';
            if (btn.order === 1) {
                this.formItem.oa = btn.key;
            } else if (btn.order === 2) {
                this.formItem.od = btn.key;
            }
            await this.search(true);
        },
        //数据检索
        async search(flg) {
            if (flg) {
                this.formItem.current = 1;
                this.$refs.page.currentPage = 1;
            }
            this.loading = true;
            await this.getCreateTime();

            let journalDto = {};
            journalDto.title = this.formItem.title;
            journalDto.type = this.formItem.type;
            journalDto.status = this.formItem.status;
            journalDto.releaseYear = this.formItem.releaseYear;
            journalDto.releaseMonth = this.formItem.releaseMonth;
            journalDto.oa = this.formItem.oa;
            journalDto.od = this.formItem.od;
            journalDto.current = this.formItem.current;
            journalDto.size = this.formItem.size;
            if (this.formItem.releaseDate != null) {
                let dataArr = this.formItem.releaseDate.split('/');
                journalDto.releaseYear = dataArr[0];
                if (this.formItem.type == '1' && dataArr.length == 2) {
                    journalDto.releaseMonth = dataArr[1];
                }
            }
            const result = await getJournalList(journalDto);
            if (result !== null) {
                this.data = result.page.records;
                this.total = result.page.total;
            }
            this.loading = false;
        }, // 页号改变
        async pageChange() {
            this.formItem.current = this.$refs.page.currentPage;
            await this.search(false);
        },
        // 每页显示数据
        async pageSizeChange() {
            this.formItem.size = this.$refs.page.currentPageSize;
            await this.search(false);
        },
        //创建时间作成
        async getCreateTime() {
            this.formItem.createTime = '';
            if (this.formItem.createStartTime !== '' && this.formItem.createStartTime !== undefined) {
                this.formItem.createTime = this.formItem.createStartTime + ',';
            }
            if (this.formItem.createEndTime !== '' && this.formItem.createEndTime !== undefined) {
                if (this.formItem.createStartTime === '' || this.formItem.createStartTime === undefined) {
                    this.formItem.createTime = ',';
                }
                this.formItem.createTime += this.formItem.createEndTime;
            }
        },
        // 删除
        async del(id) {
            await del(id);
            await this.search(true);
        },
        // 批量删除
        async delAll() {
            if (this.selectIds.length == 0) {
                Message.error({
                    content: this.msgUtil.message.warn.notSelectedRow,
                    duration: 60,
                    closable: true,
                });
                return;
            }
            await delAll(this.selectIds);
            await this.search(true);
        },
        // 行选择
        rowSelect(selection) {
            this.selectIds = selection.map(p => {
                return { id: p.id };
            });
        },
        onCreateStartTimeChange(startTime) {
            this.formItem.createStartTime = startTime;
            this.createEndTimeOption = {
                disabledDate(endTime) {
                    return endTime < new Date(startTime) || endTime > Date.now();
                },
            };
        },
        onCreateEndTimeChange(endTime) {
            this.formItem.createEndTime = endTime;
            this.createStartTimeOption = {
                disabledDate(startTime) {
                    return startTime > new Date(endTime) || startTime > Date.now();
                },
            };
        },
        handleChangeReleaseDate(releaseDate) {
            this.formItem.releaseDate = releaseDate;
        },
    },
    async mounted() {
        await this.search(true);
    },
};
</script>
<style>
</style>
